import Vue from 'vue';
import VueRouter from 'vue-router';
import type { RouteConfig } from 'vue-router';

import { isPromise } from '@/shared/util';

Vue.use(VueRouter);

/**
 * 每个路由的meta信息中可以设置以下参数
 * @param {String} title 当前页面的标题
 * @param {Boolean} excludeTracking 设置为true时表示当前路由跳过神策PV上报数据，默认为false
 * @param {String} background body背景色，默认为#f8f9ff
 */
const routes: RouteConfig[] = [
  /**
   * 下载页面
   */
  {
    path: '/download-app',
    meta: {
      excludeLogin: true,
      title: '下载宜享花',
    },
    component: () => import('@/views/download-app.vue'),
  },
  /**
   * deeplink 唤起APP
   */
  {
    path: '*',
    meta: {
      excludeLogin: true,
      title: '宜享花',
    },
    component: () => import('@/views/launching.vue'),
  },
];

export function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_PREFIX,
    routes,
    scrollBehavior() {
      return { y: 0, x: 0 };
    },
  });

  const originalPush = router.push;
  router.push = function push(...args: any) {
    const result = originalPush.apply(this, args);

    if (isPromise(result)) {
      return (result as any).catch((err: Error) => err);
    }
  };

  const originalReplace = router.replace;
  router.replace = function replace(...args: any) {
    const result = originalReplace.apply(this, args);

    if (isPromise(result)) {
      return (result as any).catch((err: Error) => err);
    }
  };

  return router;
}
